import { ArrowLeftIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import useProfile from "features/Profile/useProfile";

import useIsActive from "hooks/useIsActive";

import { ROUTES } from "utils/constants";

import Header from "components/Header";
import MainMenu from "components/MainMenu";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "components/Tabs";

import AboutMe from "./AboutMe";
import Clinic from "./Clinic";
import Findings from "./Findings";

export default function Profile() {
  const { t } = useTranslation();

  useIsActive();

  const { activeTab, changeTab } = useProfile();

  return (
    <>
      <Header className="justify-between">
        <div className="flex items-center gap-2">
          <Link to={ROUTES.HOME} className="flex items-center cursor-pointer">
            <ArrowLeftIcon />
          </Link>
          {t("menu.myProfile")}
        </div>
        <MainMenu />
      </Header>

      <Tabs
        value={activeTab}
        onValueChange={changeTab}
        className="flex-1 flex flex-col mt-6 px-4 md:px-0 mb-16 gap-6 pb-10"
      >
        <TabsList className="w-full max-w-[670px] mx-auto shrink-0">
          <TabsTrigger value="aboutMe">{t("profile.aboutMe.title")}</TabsTrigger>
          <TabsTrigger value="findings">{t("profile.findings.title")}</TabsTrigger>
          <TabsTrigger value="clinic">{t("profile.clinic.title")}</TabsTrigger>
        </TabsList>

        <TabsContent value="aboutMe">
          <AboutMe />
        </TabsContent>
        <TabsContent value="findings">
          <Findings />
        </TabsContent>
        <TabsContent value="clinic">
          <Clinic />
        </TabsContent>
      </Tabs>
    </>
  );
}
